<div id="conten-main" class="container-fluid">
    <router-outlet></router-outlet>
</div>
<footer class="container">
    <div class="version">Versión: {{version}}<br>General Security © 2024. Todos los derechos reservados.</div>
</footer>